import {useEffect, useState} from 'react';

import {isBrowser} from 'lib/Browser';

export default function useMonaco(): null | typeof import('monaco-editor/esm/vs/editor/editor.api') {
  const [monacoEditor, setMonacoEditor] = useState<
    null | typeof import('monaco-editor/esm/vs/editor/editor.api')
  >(null);

  useEffect(() => {
    const load = async (): Promise<void> => {
      const importedMonaco = await import(
        /* webpackChunkName: "monaco-editor" */ 'monaco-editor/esm/vs/editor/editor.api'
      );
      // configure custom themes
      importedMonaco.editor.defineTheme('noDiffHighlight', {
        base: 'vs',
        inherit: true,
        rules: [],
        colors: {
          'diffEditor.insertedTextBackground': '#00000000', // Fully transparent
          'diffEditor.insertedLineBackground': '#00000000',
          'diffEditor.removedTextBackground': '#00000000',
          'diffEditor.removedLineBackground': '#00000000',
          'diffEditor.insertedTextBorder': '#00000000',
          'diffEditor.removedTextBorder': '#00000000',
        },
      });
      setMonacoEditor(importedMonaco);
    };
    if (isBrowser) {
      // monaco is not supported in environments outside of the browser e.g. node
      load();
    }
  }, []);

  return monacoEditor;
}
